// ======================================================================
// File: src/modules/ipe/dashboard/crm/CRMDashboard.jsx
// Purpose:
// CRM Dashboard Router
// ======================================================================

import React from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import CRMDashboardNavigator
from "./components/CRMDashboardNavigator";

import CRMExecutiveDashboard
from "./pages/CRMExecutiveDashboard";

import CRMOperationsDashboard
from "./pages/CRMOperationsDashboard";

import CRMAnalyticsDashboard
from "./pages/CRMAnalyticsDashboard";

import CRMReportsDashboard
from "./pages/CRMReportsDashboard";

export default function CRMDashboard() {
  return (
    <div>

      <CRMDashboardNavigator />

      <Routes>

        {/* DEFAULT */}

        <Route
          index
          element={
            <Navigate
              to="executive"
              replace
            />
          }
        />

        {/* EXECUTIVE */}

        <Route
          path="executive"
          element={
            <CRMExecutiveDashboard />
          }
        />

        {/* OPERATIONS */}

        <Route
          path="operations"
          element={
            <CRMOperationsDashboard />
          }
        />

        {/* ANALYTICS */}

        <Route
          path="analytics"
          element={
            <CRMAnalyticsDashboard />
          }
        />

        {/* REPORTS */}

        <Route
          path="reports"
          element={
            <CRMReportsDashboard />
          }
        />

        {/* FALLBACK */}

        <Route
          path="*"
          element={
            <Navigate
              to="executive"
              replace
            />
          }
        />

      </Routes>

    </div>
  );
}